module.exports = __webpack_public_path__ + "img/step1-1.8945c3cd.png";